import { SELLABLE_FEATURES_AIRLINES, NON_INCLUDED_FEATURES_AIRLINES } from "@flights/ancillaries-universal";
import { carrierUtils } from "@flights/web-api-utils-universal";
import { createTrackingUtils } from "../index.js";
const utils = createTrackingUtils({
    name: "flights_apex_web_filter_align_branded_fare_features_apps",
    defaultStage: 1,
    stages: {
        main: 1,
        search_results: 2,
        branded_fares_page: 3,
        sellable_features_carrier: 4,
        excluded_features_carrier: 5,
        mileage_accrual_carrier: 6,
        sellable_lounge_access_carrier: 7,
        executive_lounge_access_carrier: 8
    },
    goals: {
        sellable_features_present: 1,
        non_included_features_present: 2,
        sellable_lounge_access_present: 3,
        mileage_accrual_present: 4,
        executive_lounge_access_present: 5
    }
});
const hasCarrier = (flightSegments, carrierCodes) => carrierUtils.hasMarketingCarrier(flightSegments, [...carrierCodes]);
const isFeatureVisible = (features, featureName) => features.some((feature) => feature.featureName === featureName);
export const trackAlignedBrandedFareFeaturesStages = (page, flightSegments) => {
    utils.stages.main();
    if (page === "search_results") {
        utils.stages.search_results();
    }
    else {
        utils.stages.branded_fares_page();
    }
    if (hasCarrier(flightSegments, SELLABLE_FEATURES_AIRLINES)) {
        utils.stages.sellable_features_carrier();
    }
    if (hasCarrier(flightSegments, NON_INCLUDED_FEATURES_AIRLINES)) {
        utils.stages.excluded_features_carrier();
    }
    if (hasCarrier(flightSegments, ["AA"])) {
        utils.stages.mileage_accrual_carrier();
    }
    if (hasCarrier(flightSegments, ["EY"])) {
        utils.stages.sellable_lounge_access_carrier();
    }
    if (hasCarrier(flightSegments, ["UA"])) {
        utils.stages.executive_lounge_access_carrier();
    }
};
export const trackAlignedBrandedFareFeaturesGoals = ({ displayedIncludedFeatures, displayedSellableFeatures, displayedNonIncludedFeatures }) => {
    const displayedFeatures = [
        ...displayedIncludedFeatures,
        ...displayedSellableFeatures,
        ...displayedNonIncludedFeatures
    ];
    if (displayedSellableFeatures.length > 0) {
        utils.goals.sellable_features_present();
    }
    if (displayedNonIncludedFeatures.length > 0) {
        utils.goals.non_included_features_present();
    }
    if (isFeatureVisible(displayedSellableFeatures, "LOUNGE_ACCESS")) {
        utils.goals.sellable_lounge_access_present();
    }
    if (isFeatureVisible(displayedFeatures, "MILEAGE_ACCRUAL")) {
        utils.goals.mileage_accrual_present();
    }
    if (isFeatureVisible(displayedFeatures, "EXECUTIVE_LOUNGE")) {
        utils.goals.executive_lounge_access_present();
    }
};
export default utils;
